"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _excluded = ["classes", "className", "theme"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*:: import { type ThemeType, type InjectSheetProvidedProps } from '../../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: _objectSpread({}, theme.mixins.infoBarLabel)
  };
};
/*:: type Props = InjectSheetProvidedProps & HTMLElement;*/
var InfoBarItemTitle = function InfoBarItemTitle(_ref /*:: */) {
  var classes = _ref /*:: */.classes,
    className = _ref /*:: */.className,
    theme = _ref /*:: */.theme,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, props));
};
InfoBarItemTitle.displayName = 'InfoBarItemTitle';
var _default = exports.default = (0, _injectSheet.default)(Style)(InfoBarItemTitle);
//# sourceMappingURL=InfoBarItemTitle.js.map